export default "__VITE_ASSET__C9suhE8U__"